export default __webpack_public_path__ + "static/media/RistekLogoLight-2026.3a3e4bc7.svg";